import Product from '../../interfaces/Product';
import Typography from '@material-ui/core/Typography';
import DatePromo from './DatePromo/DatePromo';
import { ImageProductCore, ImageProductDiv, AlignBoxContent, StoreStyled } from './Details.styles';
import NotExistsImageProduct from '../../../../assets/noProductImg.png';
import useModal from '../../../../hooks/useModal';
import ModalImg from '../../../../component/modal/modalImg/ModalImg.component';
import GridComponent from '../../../../component/grid/GridComponent.component';
import { Grid } from '@material-ui/core';
import { BiStoreAlt } from 'react-icons/bi';
import { formatMonetary } from '../../../../utils/format/FormatMonetary';
import ProductInformation from './ProductInformation.component';

interface ServiceComponentInterface {
  product?: Product;
}

export default function ServiceComponent({ product }: ServiceComponentInterface) {
  const [open, addModal] = useModal();

  if (!product) {
    return <div>Produto não existe nesta loja!</div>
  }

  return (
    <GridComponent alignItems="flex-start">
      <ModalImg open={!!open} onClick={() => addModal(!open)} img={product?.URLIMAGEM || NotExistsImageProduct} />
      <ImageProductDiv cursor='pointer' onClick={() => addModal(!open)}>
        <ImageProductCore src={product?.URLIMAGEM || NotExistsImageProduct} alt="Product Image" />
      </ImageProductDiv>
      <AlignBoxContent>
        <StoreStyled>
          <BiStoreAlt size={26} />
          {product?.WERKS_NOME}
        </StoreStyled>

        <Typography component="h4" variant="h4">
          {product?.MAKTX}
        </Typography>

        <GridComponent margin={'0px 0px 10px 0px'} alignItems="flex-start">
          <Grid item xs={12} sm={12} md={6}>
            <div style={{ display: 'flex', padding: 0 }}>
              <ProductInformation title='Cód. SAP' titleTooltip='Código SAP do produto.' value={`${Number(product?.MATNR)}`} />
              <ProductInformation title='EAN' titleTooltip='Código de barras do produto.' value={String(product?.EAN11 || '')} />
            </div>
            <div style={{ display: 'flex', padding: 0 }}>
              <ProductInformation title='Estoque loja' titleTooltip='Estoque disponível na loja.' value={`${Number(product?.ESTOQUE)} ${product?.MEINS}`} />
              {/* <ContentBoxIcon><Tooltip title="Quantidade de itens dentro da embalagem de venda." aria-label="add" placement="top" arrow><BoxIcon><BiInfoCircle size={20} /></BoxIcon></Tooltip><Text title='QTD EMB' value={`${product?.QTDEMB} ${product?.MEINS}`} /></ContentBoxIcon> */}
            </div>

            <ProductInformation title='Preço Regular' titleTooltip='Preço normal da mercadoria.' value={`R$ ${formatMonetary(product?.REGULAR || 0)}`} />

            <div>Obs.: Preços válidos na data de hoje ou enquanto durar o estoque.</div>

          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            {product?.DATA_INI_PROMO && (
              <>
                <ProductInformation title='Preço em Promoção' titleTooltip='Preço Promocional' value={`R$ ${formatMonetary(product?.VIGENTE || 0)}`} />
                <ProductInformation title='' titleTooltip='Validade da Promoção' value='' >
                  <DatePromo startData={product?.DATA_INI_PROMO} endData={product?.DATA_FIM_PROMO} />
                </ProductInformation>
              </>
            )}

            {product?.CLUBE ? (
              <ProductInformation
                title='Preço Clube'
                titleTooltip='Preço para o clube de relacionamento com o cliente, é ativado para os clientes que fazem a identificação por CPF no momento da venda.'
                value={`R$ ${formatMonetary(product?.CLUBE)}`}
              />
            ) : <></>
            }
            {/* <ContentBoxIcon><Tooltip title="Preço a ser praticado nas compras acima de uma determinada quantidade do produto." aria-label="add" placement="top" arrow><BoxIcon><BiInfoCircle size={20} /></BoxIcon></Tooltip><Text title='Preço APD' value={''} /></ContentBoxIcon>
            <ContentBoxIcon><Tooltip title="Preço praticado no e-commerce." aria-label="add" placement="top" arrow><BoxIcon><BiInfoCircle size={20} /></BoxIcon></Tooltip><Text title='Preço E-Commerce' value={''} /></ContentBoxIcon> */}
          </Grid>
        </GridComponent>
      </AlignBoxContent>
    </GridComponent>
  );
}
